<template>
  <div>
    <PersonList :persons="dorms" v-if="dorms"/>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
    <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>      
  </div>

</template>

<script>
import PersonList from '@/components/PersonList'
import FixedPopup from '@/components/FixedPopup'
import InfiniteLoading from 'vue-infinite-loading'
import axios from 'axios'
import { SET_TOTAL_RESULTS } from '@/store/mutations.type'
export default {
  name: 'PersonDistinct',
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.district ? this.district.title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.district ? this.district.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.district ? this.district.keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]
    }
  },
  components: {
    PersonList,
    FixedPopup,
    InfiniteLoading
  },
  data () {
    return {
      page: 1,
      dorms: null,
      popupDorms: null,
      errors: [],
      district: null,
      url: '',
      directors: [
{
      popularity: 8.896,
      known_for_department: "Directing",
      name: "George Lucas",
      id: 1,
      profile_path: "/mDLDvsx8PaZoEThkBdyaG1JxPdf.jpg",
      adult: false,
      gender: 2
},
{
      popularity: 7.989,
      known_for_department: "Directing",
      gender: 2,
      id: 1032,
      profile_path: "/4Xwx5XL1RJj0JQmEo8Fhr6nkpOg.jpg",
		  name: "Martin Scorsese"
},
{
    
      popularity: 8.816,
      known_for_department: "Directing",
      name: "Steven Spielberg",
      id: 488,
      profile_path: "/3MiyGfhQZhfLTuoaGdusXz5awRU.jpg",
      adult: false,
      gender: 2
    },      
{
      popularity: 7.18,
      known_for_department: "Directing",
      name: "Jon Favreau",
      id: 15277,
      profile_path: "/rOVBKURoR7TrG8MYxTuNUFj3E68.jpg",
      adult: false,
      gender: 2
},
{
      popularity: 7.104,
      known_for_department: "Directing",
      name: "Quentin Tarantino",
      id: 138,
      profile_path: "/f00gwMDBfJh6D5c7KQan6eek9h6.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 7.053,
      known_for_department: "Directing",
      gender: 2,
      id: 525,
      profile_path: "/7I18crrTkJzs050YVYfg2YuP0fK.jpg",
      adult: false,
	name: "Christopher Nolan"
},
{
      popularity: 6.842,
      known_for_department: "Directing",
      name: "Bong Joon-ho",
      id: 21684,
      profile_path: "/stwnTvZAoD8gEJEDHpDQyLCyDy5.jpg",
      adult: false,
gender: 2
},
{
      popularity: 6.763,
      known_for_department: "Directing",
      name: "Joe Russo",
      id: 19272,
      profile_path: "/679Os4tbY1YsU01KdLhM1NPXNWu.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 6.167,
      known_for_department: "Directing",
      name: "Ridley Scott",
      id: 578,
      profile_path: "/zABJmN9opmqD4orWl3KSdCaSo7Q.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 6.159,
      known_for_department: "Directing",
      name: "P. S. Keerthana",
      id: 238025,
      profile_path: "/cxGh4lJW2SqQUs4tvW1W7eOtQNI.jpg",
      adult: false,
	gender: 1
},
{
      popularity: 6.055,
      known_for_department: "Directing",
      name: "Kevin Smith",
      id: 19303,
      profile_path: "/r3f3qyD6pPGUKHMAZbqQf8IhclX.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 5.839,
      known_for_department: "Directing",
      name: "Zack Snyder",
      id: 15217,
      profile_path: "/iD0GDqkvJXDXiNEZej198hjt3Tt.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 5.865,
      known_for_department: "Directing",
      name: "Alfred Hitchcock",
      id: 2636,
      profile_path: "/7m3IkKteGvcAfI9m2AoZGcss8sy.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 5.79,
      known_for_department: "Directing",
      name: "Hayao Miyazaki",
      id: 608,
      profile_path: "/1OBQPIwR88n49oAEzk47k0fhhOV.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 5.739,
      known_for_department: "Directing",
      name: "Akira Kurosawa",
      id: 5026,
      profile_path: "/7MTiuRIaAFlYLZMOJDysFNCqhGA.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 5.717,
      known_for_department: "Directing",
      name: "James Cameron",
      id: 2710,
      profile_path: "/9DDaI9npzCsMXjlGQNuoUEPCHfm.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 5.641,
      known_for_department: "Directing",
      name: "Taika Waititi",
      gender: 2,
      id: 55934,
      profile_path: "/bqecNGun4FHvKqXga6D9V51DTBN.jpg",
      adult: false,
	name: "Taika Waititi"
},
{
      popularity: 5.635,
      known_for_department: "Directing",
      name: "J.J. Abrams",
      id: 15344,
      profile_path: "/h0o12c399M5hTKWl0qdgwhaddNt.jpg",
      adult: false,
      gender: 2
},
{
      popularity: 5.614,
      known_for_department: "Directing",
      gender: 2,
      id: 59,
      profile_path: "/p7QoPAMP6wfkgcwELkM5VtdGYHU.jpg",
      adult: false,
	name: "Luc Besson"
},
{
      popularity: 4.617,
      known_for_department: "Directing",
      name: "Guillermo del Toro",
      id: 10828,
      profile_path: "/xFByaHBR8jb3N5D5PccVN06l9lk.jpg",
      adult: false,
	gender: 2,
},
{
      popularity: 4.49,
      known_for_department: "Directing",
      gender: 2,
      id: 4027,
      profile_path: "/6U1eHg30snkOhSM9WJT2asAesR9.jpg",
      adult: false,
	name: "Frank Darabont"
},
{
      popularity: 4.449,
      known_for_department: "Directing",
      name: "Guy Ritchie",
      id: 956,
      profile_path: "/yrWmxapB0CbFtm8tkfJkHkXsmtr.jpg",
	gender: 2
},
{
      popularity: 4.408,
      known_for_department: "Directing",
      name: "James Wan",
      id: 2127,
      profile_path: "/9AlAMoHVDUX8GVOTw6JOyKil8k9.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 4.399,
      known_for_department: "Directing",
      gender: 2,
      id: 1776,
      profile_path: "/vEGwqahu7UlI6OwELy92xbXk9Kd.jpg",
      adult: false,
  	name: "Francis Ford Coppola"
},
{
      popularity: 4.256,
      known_for_department: "Directing",
      name: "Edgar Wright",
      id: 11090,
      profile_path: "/dQzv5Ml2SkelS33hgl7E2oh0a9S.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 4.23,
      known_for_department: "Directing",
      name: "Darren Aronofsky",
      id: 6431,
      profile_path: "/AtBEqPkWw5txAuMJ5vk4dFhmMrR.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 4.22,
      known_for_department: "Directing",
      name: "Ingmar Bergman",
      id: 6648,
      profile_path: "/nkmOaXNRoioViN9OQf2n9Iu6akA.jpg",
      adult: false,
	gender: 2
},
    {
      popularity: 4.214,
      known_for_department: "Directing",
      name: "Wes Anderson",
      id: 5655,
      profile_path: "/oKDlhTjORiTQriqoUFJMTgGiwPg.jpg",
	gender: 2
},
{
      popularity: 4.203,
      known_for_department: "Directing",
      name: "Brad Bird",
      id: 7087,
      profile_path: "/ZX1hAfWK1zslpB6ifwgDP2uBqn.jpg",
      adult: false,
	gender:2
},

{
      popularity: 4.18,
      known_for_department: "Directing",
      name: "Werner Herzog",
      gender: 2,
      id: 6818,
      profile_path: "/qKlz1oM482Xf0jTPfLiR6qXlLYK.jpg",
      adult: false,
      gender: 2
},
{
      popularity: 4.147,
      known_for_department: "Directing",
      name: "Denis Villeneuve",
      id: 137427,
      profile_path: "/433lXlkdMGXzrpwnKM4Ul1sln15.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 4.127,
      known_for_department: "Directing",
      name: "Tim Burton",
      id: 510,
      profile_path: "/yHEHAHQpN9PfSEQx1UxZPczhcAi.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 4.112,
      known_for_department: "Directing",
      name: "David Yates",
      id: 11343,
      profile_path: "/fiIZNbwdK07ntpE2wpLRIMuSXEy.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 4.121,
      known_for_department: "Directing",
      name: "Robert Zemeckis",
      id: 24,
      profile_path: "/ryiZwDAQg18IdE9gfiM4Go3ankT.jpg",
      adult: false,
	gender: 2
},


{
      popularity: 4.086,
      known_for_department: "Directing",
      name: "Richard Linklater",
      id: 564,
      profile_path: "/wNijRefhQCp0BkNqM5qhhdazDgx.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 3.959,
      known_for_department: "Directing",
      gender: 2,
      id: 40684,
      profile_path: "/htO4qu7yMUfZzJR9DF9iXch8ina.jpg",
      adult: false,
	gender: 2,
	name: "David Leitch"
},
    {
      popularity: 3.842,
      known_for_department: "Directing",
      gender: 2,
      id: 31493,
      profile_path: "/z6EfePu3eDjgvws8IiwzYqzD1Wr.jpg",
      adult: false,
	gender: 2,
 name: "Alex Cox"
},
    {
      popularity: 3.828,
      known_for_department: "Directing",
      name: "Sam Mendes",
      id: 39,
      profile_path: "/5z89X9rB76JDblqMQ52fviwXxAN.jpg",
      adult: false,
      gender:2
    },
    {
      popularity: 3.822,
      known_for_department: "Directing",
      name: "David Lynch",
      id: 5602,
      profile_path: "/b6TnSpuqeOlbq7aHH9G4inmQ1v9.jpg",
      adult: false,
	gender:2
},
    {
      popularity: 3.788,
      known_for_department: "Directing",
      name: "Colin Trevorrow",
      id: 930707,
      profile_path: "/i0HBClPMPKn3aq8QeQqyThS67EK.jpg",
      adult: false,
      gender: 2
    },
    {
      popularity: 3.781,
      known_for_department: "Directing",
      name: "Lee Unkrich",
      gender: 2,
      id: 8,
      profile_path: "/oeUkLlak2lqKRYZmJZZv5gI87Ok.jpg",
      adult: false
    },
{
      popularity: 3.762,
      known_for_department: "Directing",
      name: "Orson Welles",
      gender: 2,
      id: 40,
      profile_path: "/c5wKlmD001cQAqJjvDbVOTVeAyV.jpg",
      adult: false,
},
{
      popularity: 3.693,
      known_for_department: "Directing",
      gender: 2,
      id: 3556,
      profile_path: "/5yMO7d7NsODZtCwF22Xnlp3oVnE.jpg",
      adult: false,
      gender: 2
},
{
      popularity: 3.503,
      known_for_department: "Directing",
      name: "Stanley Kubrick",
      id: 240,
      profile_path: "/6K3ycyLeadkwMUPOCCOUr6OYY13.jpg",
      adult: false,
      gender: 2 
},    
    {
      popularity: 3.47,
      known_for_department: "Directing",
      adult: false,
      id: 11614,
      profile_path: "/uLgGi0p8qKIvQxi8ESwzkrJJ2Wu.jpg",
      name: "M. Night Shyamalan",
      gender:2
    },
    {
      popularity: 3.427,
      known_for_department: "Directing",
      name: "M.J. Bassett",
      id: 69593,
      profile_path: "/sgoxX8KRIn34s1yLeOvJYyKw8XE.jpg",
      adult: false,
      gender: 1
    },
   {
      popularity: 3.263,
      known_for_department: "Directing",
      name: "Tom Hooper",
      id: 70500,
      profile_path: "/wRuokdzGiSh2MHd9cYQQ9KGVFFj.jpg",
      adult: false,
      gender:2
   },
{
          
      popularity: 3.049,
      known_for_department: "Directing",
      name: "Woody Allen",
      gender: 2,
      id: 1243,
      profile_path: "/t6RBHxD32bxoePKOHoW7iTyJk1u.jpg",
      adult: false,
      gender:2
},
    {
      popularity: 3.874,
      known_for_department: "Directing",
      name: "Rian Johnson",
      id: 67367,
      profile_path: "/uPWwvdppeZVKPbYcjXKU8zyuAVh.jpg",
      adult: false,
      gender: 2
    },
{
      popularity: 3.77,
      known_for_department: "Directing",
      name: "Gore Verbinski",
      id: 1704,
      profile_path: "/rSQRdmLNAwdKxrtvBSSlBmWeSsj.jpg",
	  gender: 2
},
    {
      popularity: 3.77,
      known_for_department: "Directing",
      name: "David Yates",
      id: 11343,
      profile_path: "/fiIZNbwdK07ntpE2wpLRIMuSXEy.jpg",
      adult: false,
      gender: 2
    },
    {
      popularity: 3.756,
      known_for_department: "Directing",
      name: "Park Chan-wook",
      gender: 2,
      id: 10099,
      profile_path: "/cEQTyD079f6OTg44menO5AQrZ4i.jpg",
      adult: false,
    },
    {
      popularity: 3.755,
      known_for_department: "Directing",
      name: "Tony Scott",
      gender: 2,
      id: 893,
      profile_path: "/2Cj0IqkQcWRydXyr5moaNu5yqTH.jpg",
      adult: false,
    },    
{
      popularity: 3.738,
      known_for_department: "Directing",
      gender: 2,
      id: 2034,
      profile_path: "/b5qQpFHmgNyvV1t81ou17Jt2fRj.jpg",
      adult: false,
	gender: 2,
	name: "Danny Boyle"
},
    {
      popularity: 3.735,
      known_for_department: "Directing",
      gender: 2,
      id: 8452,
      profile_path: "/j0toVLrgLNuyGnUxGPnSfnPiSf5.jpg",
      adult: false,
     name: "Andrey Tarkovsky"
    },
    {
      popularity: 3.716,
      known_for_department: "Directing",
      name: "Thiago Cazado",
      gender: 2,
      id: 1709759,
      profile_path: "/wxEohpTXhDPTN5rHI0ALYCCTDsQ.jpg",
      adult: false,
    },
    {
      popularity: 3.662,
      known_for_department: "Directing",
      name: "Roland Emmerich",
      id: 6046,
      profile_path: "/5zegR2csDWGpnCwDReKNqDsduKY.jpg",
      adult: false,
      gender: 2
    },
    {
      popularity: 3.649,
      known_for_department: "Directing",
      name: "Justin Lin",
      gender: 2,
      id: 58189,
      profile_path: "/nQjC9NUQRiDyMP8sA4AdkgSKTrv.jpg",
      adult: false,
    },  
{    
      popularity: 3.539,
      known_for_department: "Directing",
      name: "Wes Anderson",
      id: 5655,
      profile_path: "/oKDlhTjORiTQriqoUFJMTgGiwPg.jpg",
      adult: false,
      gender: 2
    },
    {
      popularity: 2.846,
      known_for_department: "Directing",
      name: "Sam Liu",
      id: 90367,
      profile_path: "/3u01dPeS4Us9sUFzwS8DzjA3udr.jpg",
      adult: false,
      gender: 2
    },       
{
      popularity: 2.84,
      known_for_department: "Directing",
      name: "David Fincher",
      id: 7467,
      profile_path: "/rEZCQi39YNa06FleHzLc8JUpw6S.jpg",
      adult: false,
      gender:2
},

    {
      popularity: 2.727,
      known_for_department: "Directing",
      name: "Robert Rodriguez",
      id: 2294,
      profile_path: "/bPqRdLWWwpOT8sBdj9PWOzNgwou.jpg",
      adult: false,
      gender: 2
},
{
      popularity: 2.75,
      known_for_department: "Directing",
      name: "Spike Jonze",
      id: 5953,
      profile_path: "/x2QeqEXvi3QjgTybvZ4mmqUf4qO.jpg",
      adult: false,
      gender: 2
},
{
      popularity: 3.302,
      known_for_department: "Directing",
      name: "Peter Jackson",
      id: 108,
      profile_path: "/kSrfI3TbMdIMmPVOflLQ56OfscB.jpg",
      adult: false,
      gender: 2
},
    {
      popularity: 2.554,
      known_for_department: "Directing",
      name: "Sam Raimi",
      id: 7623,
      profile_path: "/rJJYL7N8OBL31K4anhZGv30NiL1.jpg",
      adult: false,
      gender: 2
    },
{
      popularity: 2.384,
      known_for_department: "Directing",
      name: "Ernst Lubitsch",
      gender: 2,
      id: 2428,
      profile_path: "/tAsEhwiu3oqDgzCZSYN2xu0dEdD.jpg",
      adult: false,
},
{
      popularity: 2.268,
      known_for_department: "Directing",
      name: "Francis Lawrence",
      id: 10943,
      profile_path: "/pyGWo5mAwZ2Koe6leB2RjKd7vmc.jpg",
      adult: false,
      gender: 2
},
    {
      popularity: 2.181,
      known_for_department: "Directing",
      name: "Spike Lee",
      id: 5281,
      profile_path: "/2KOHXgk2uoRXl6u7V9xpAIo3uay.jpg",
      adult: false,
      gender: 2
    },
    {
      popularity: 1.788,
      known_for_department: "Directing",
      gender: 0,
      id: 37360,
      profile_path: "/pXnCjOCLAXWf1hE1tdVA4ANR6BB.jpg",
      adult: false,
      gender: 2
    },    
{
      popularity: 1.168,
      known_for_department: "Directing",
      name: "Frank Capra",
      id: 2662,
      profile_path: "/1OTZ7CEdEawDgA4qiBidpWTKE2x.jpg",
      adult: false,
      gender: 2
},
{
      popularity: 0.98,
      known_for_department: "Directing",
      name: "Poj Arnon",
      gender: 2,
      id: 111984,
      profile_path: "/bETWd45bkio5LDAewuVDTBB1S1u.jpg",
      adult: false,
},
{
      popularity: 0.887,
      known_for_department: "Directing",
      name: "Cecil B. DeMille",
      gender: 2,
      id: 8636,
      profile_path: "/xMh7QPEm6bohkpmyGIvbWaq6097.jpg",
      adult: false,
      
}
      ],
writers: [
      {
      popularity: 11.043,
      known_for_department: "Writing",
      name: "Stephen King",
      id: 3027,
      profile_path: "/agBYOVxOoywmNVajklMCQRvjdnQ.jpg",
      adult: false,
      gender: 2
    },
    {
      popularity: 3.795,
      known_for_department: "Writing",
      name: "Charlie Brooker",
      id: 211845,
      profile_path: "/dmdLd5I4cnpCZzoITm26NOwu6Rn.jpg",
      adult: false,
      gender: 2,
    },
    {
      popularity: 3.787,
      known_for_department: "Writing",
      name: "René Goscinny",
      id: 24530,
      profile_path: "/nm4ZK0nE7eXvyaGBit4VQ3sdPij.jpg",
      adult: false,
      gender:2
    },
    {
      popularity: 3.632,
      known_for_department: "Writing",
      name: "Jennifer Lee",
      id: 1120694,
      profile_path: "/pjZY7hdneR7FLrAT0mXNR6RrPfy.jpg",
      adult: false,
      gender: 1
    },   
{
      popularity: 3.82,
      known_for_department: "Writing",
      name: "Joel Coen",
      id: 1223,
      profile_path: "/rgVaJNkZCgMarUcZuUAsVfXMWk3.jpg",
      adult: false,
	gender: 2
},
    {
      popularity: 3.579,
      known_for_department: "Writing",
      name: "George Pelecanos",
      id: 203725,
      profile_path: "/vpr5BLJqGDVd7ASZs10OzXCLO9D.jpg",
      adult: false,
      gender: 2
    },
{
      popularity: 5.155,
      known_for_department: "Writing",
      name: "Geoff Johns",
      id: 211962,
      profile_path: "/1hiQjkIkeFoiwvD4yIk2Dq6tnOa.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 4.828,
      known_for_department: "Writing",
      name: "Wallace Wolodarsky",
      id: 486,
      profile_path: "/a6npTg5wUQIHkyH17m5FPc9hJPV.jpg",
      adult: false,
	gender: 2,
},
{
      popularity: 4.66,
      known_for_department: "Writing",
      name: "Stephen McFeely",
      id: 5552,
      profile_path: "/hkn9D5L8TguJUmv8fXy5sHyMEtq.jpg",
      adult: false,
	gender: 2
},
 {
      popularity: 4.526,
      known_for_department: "Writing",
      name: "Ethan Coen",
      id: 1224,
      profile_path: "/AH5YwNZC5txyJKyjVZhA4ZXFzP.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 4.453,
      known_for_department: "Writing",
      name: "Christopher Markus",
      id: 5551,
      profile_path: "/7ooPNp0gnURxYkSSKF2etH7wpZP.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 4.328,
      known_for_department: "Writing",
      name: "Joss Whedon",
      id: 12891,
      profile_path: "/mVvpZnKYKSCtkOQixQnOonV5kv3.jpg",
      adult: false,
	gender: 2
},
    {
      popularity: 4.211,
      known_for_department: "Writing",
      name: "Lana Wachowski",
      id: 9340,
      profile_path: "/ppGicszb7PxGDAI2F6qBTXrn1t0.jpg",
      adult: false,
      gender: 2
},
{
      popularity: 4.21,
      known_for_department: "Writing",
      name: "Christopher McQuarrie",
      id: 9033,
      profile_path: "/xVbQBRpqzKkllUAvjJbgnAmTwaZ.jpg",
      adult: false,
	gender: 2
},
 {
      popularity: 4.177,
      known_for_department: "Writing",
      name: "Lilly Wachowski",
      id: 9339,
      profile_path: "/9sxE10LUA7TGlS1pHw2RM6mckHp.jpg",
      adult: false,
	gender:1
},
{
      popularity: 3.965,
      known_for_department: "Writing",
      name: "Lawrence Kasdan",
      id: 8844,
      profile_path: "/hZAQC6MLyR1oLHRKEZ1oUEvh0Sy.jpg",
      adult: false,
	gender:2
},
{
      popularity: 3.965,
      known_for_department: "Writing",
      name: "Lawrence Kasdan",
      id: 8844,
      profile_path: "/hZAQC6MLyR1oLHRKEZ1oUEvh0Sy.jpg",
      adult: false,
	gender:2
},
{
      popularity: 3.927,
      known_for_department: "Writing",
      name: "Akiva Goldsman",
      id: 5575,
      profile_path: "/zjnY7yoXZifRJR9x8hdGIm9ducG.jpg",
      adult: false,
	gender:2
},
{
      popularity: 1.903,
      known_for_department: "Writing",
      name: "Aaron Sorkin",
      id: 13520,
      profile_path: "/26kuOFfR2RgcNqq6fm2qdWq0kyI.jpg",
      adult: false,
      gender: 2
},
    {
      popularity: 3.561,
      known_for_department: "Writing",
      name: "Derek Connolly",
      id: 1020013,
      profile_path: "/k1VQLCP4RAAkuXZ5HWrdL1NQnWR.jpg",
      adult: false,
      gender: 2
    },
    {
      popularity: 3.548,
      known_for_department: "Writing",
      name: "James Gray",
      gender: 2,
      id: 20561,
      profile_path: "/6oRlizIlhI2exF3OEGvtB6M7KmZ.jpg",
      adult: false,
    },  
    {
      popularity: 3.35,
      known_for_department: "Writing",
      gender: 2,
      id: 3146,
      profile_path: "/nWV9BDDCbRegP7etiPjl3vYnJEq.jpg",
      adult: false,
      name: "Billy Wilder"
    },
{
      popularity: 1.858,
      known_for_department: "Writing",
      name: "Samuel Hoffenstein",
      gender: 2,
      id: 29596,
      profile_path: "/bCcwLNOgI1otEm8IF4k93KuQMw0.jpg",
      adult: false,
},     
{
      popularity: 1.4,
      known_for_department: "Writing",
      name: "David A. Goodman",
      id: 96342,
      profile_path: "/5prZa5BqZoz2q0O0OU6cBsWay5v.jpg",
      adult: false,
      gender:2
},
{
      popularity: 1.008,
      known_for_department: "Writing",
      name: "Nathaniel Goodman",
      id: 1376394,
      profile_path: "/7d3zxGih4VaTGRaqanO9FpNPvmr.jpg",
      adult: false,
      gender:2
},    
    {
      popularity: 3.612,
      known_for_department: "Writing",
      name: "John Logan",
      gender: 2,
      id: 932,
      profile_path: "/nsece2qBIAOFvavyXc89HlIqrLK.jpg",
      adult: false,
    },
    {
      popularity: 3.422,
      known_for_department: "Writing",
      name: "Billy Wilder",
      gender: 2,
      id: 3146,
      profile_path: "/nWV9BDDCbRegP7etiPjl3vYnJEq.jpg",
      adult: false,
    },
    {
      popularity: 3.409,
      known_for_department: "Writing",
      name: "Craig Mazin",
      id: 35796,
      profile_path: "/77j3fjLKEIqTqeqGli4CWNtYxJ5.jpg",
      adult: false,
      gender:2
    },
{
      popularity: 1.4,
      known_for_department: "Writing",
      name: "Robert Towne",
      id: 11057,
      profile_path: "/pc1bpO4nljMqvz0P8A9nC6fZa1.jpg",
      adult: false,
      gender: 2,
},
{
      popularity: 1.354,
      known_for_department: "Writing",
      name: "Paul Schrader",
      id: 1035,
      profile_path: "/ctRxgCUSRFudwFaPG2AanL71Y3V.jpg",
      adult: false,
      gender:2
},
{
      popularity: 4.588,
      known_for_department: "Writing",
      name: "Fabian Nicieza",
      id: 1222480,
      profile_path: null,
      adult: false,
	gender: 1
},
{
      popularity: 4.938,
      known_for_department: "Writing",
      name: "Alex Kurtzman",
      id: 15345,
      profile_path: null,
      adult: false,
	gender: 2
},
{
      popularity: 4.446,
      known_for_department: "Writing",
      gender: 2,
      id: 18866,
      profile_path: null,
      adult: false,
	name: "Jack Kirby"
},
{
      popularity: 4.367,
      known_for_department: "Writing",
      gender: 2,
      id: 1264504,
      profile_path: null,
      adult: false,
	name: "Sajid Samji"
},
    {
      popularity: 3.883,
      known_for_department: "Writing",
      name: "Art Marcum",
      id: 18873,
      profile_path: null,
      adult: false,
	gender:2
},
    {
      popularity: 3.759,
      known_for_department: "Writing",
      gender: 0,
      id: 6685,
      profile_path: null,
      adult: false,
	 name: "Thomas Keneally"
},
    {
      popularity: 3.672,
      known_for_department: "Writing",
      gender: 1,
      id: 67360,
      profile_path: null,
	name: "Maya Forbes"
},
{
      popularity: 1.62,
      known_for_department: "Writing",
      name: "Cory Goodman",
      id: 120119,
      profile_path: null,
      adult: false,
      gender: 2
},
{
      popularity: 1.38,
      known_for_department: "Writing",
      name: "Jack Weinstein",
      id: 1340046,
      profile_path: null,
      adult: false,
      gender:2
},
{
      popularity: 2.52,
      known_for_department: "Writing",
      gender: 2,
      id: 1218279,
      profile_path: null,
      adult: false,
      name:"David Simon"
},
{
      popularity: 3.284,
      known_for_department: "Writing",
      name: "William Goldman",
      id: 348,
      profile_path: null,
      adult: false,
      gender: 2
},
],
      producers: [
    {
      popularity: 3.783,
      known_for_department: "Production",
      name: "John Lasseter",
      id: 7879,
      profile_path: "/7EdqiNbr4FRjIhKHyPPdFfEEEFG.jpg",
      adult: false,
      gender: 2
    },
    {
      popularity: 3.693,
      known_for_department: "Production",
      name: "Paul W. S. Anderson",
      id: 4014,
      profile_path: "/3LBggv2qwBVjDi45DA0RTadgw12.jpg",
      adult: false,
      gender: 2
    },
    {
      popularity: 3.562,
      known_for_department: "Production",
      name: "Carrie Hilton",
      gender: 1,
      id: 6232,
      profile_path: "/oV6zgHmWq9yfSHJ3gE33Tzpbch6.jpg",
      adult: false,
    },
    {
      popularity: 3.368,
      known_for_department: "Production",
      name: "Walt Disney",
      id: 2106,
      profile_path: "/rucTIeVtozKer6TmCYBxFr8Wy2q.jpg",
      adult: false,
      gender: 2
    },
    {
      popularity: 3.341,
      known_for_department: "Production",
      name: "Greg Berlanti",
      id: 88967,
      profile_path: "/1T24SiIIDMa9gAmq7QaYwZywq4y.jpg",
      adult: false,
      gender: 2
    },
{
      popularity: 1.712,
      known_for_department: "Production",
      name: "Scott Rudin",
      id: 2997,
      profile_path: "/zIeKeFgBERBHmabgmqZFmgcxqvO.jpg",
      adult: false,
	gender: 2
},
{
      popularity: 1.38,
      known_for_department: "Production",
      name: "Barbara Broccoli",
      id: 10666,
      profile_path: "/AhZYRh7lSJj4vXMcHHRzYDe21JA.jpg",
      adult: false,
	    gender: 1
},
    {
      popularity: 1.203,
      known_for_department: "Production",
      name: "Jerry Bruckheimer",
      id: 770,
      profile_path: "/vTKQVRrj9vOrKLkPEsXHxmpV9c3.jpg",
      adult: false,
     },
{      popularity: 0.828,
      known_for_department: "Production",
      name: "Arnon Milchan",
      id: 376,
      profile_path: "/b2hBExX4NnczNAnLuTBF4kmNhZm.jpg",
      adult: false,
	    gender: 2
},
{
      popularity: 1.008,
      known_for_department: "Production",
      name: "Sam Spiegel",
      id: 6594,
      profile_path: "/zM5qW22AbzXUE626uZD0OXNzDWD.jpg",
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Adolph Zukor",
      id: 13335,
      profile_path: "/h4gkeIGlb8fybIxrPokalu23oFX.jpg",
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Irving Thalberg",
      id: 1497,
      profile_path: "/yMR4w6n1L1zGdbTvu85UPVM4ai5.jpg",
      adult: false,
	    gender: 2
},
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Hal B. Wallis",
      id: 4123,
      profile_path: "/lia6xtKaPDmQ68BArDkqxAFj9go.jpg",
      adult: false,
	    gender: 2
},
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Harry Cohn",
      id: 29341,
      profile_path: "/8W9Elna9PhiXUQey32tzzxZSP8J.jpg",
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Waller Mirisch",
      gender: 2,
      id: 14523,
      profile_path: "/diPKMcQzIfNY2JN8tHxiGl4fsW.jpg",
      adult: false,
},
{
      popularity: 1.214,
      known_for_department: "Production",
      name: "Christopher H. Warner",
      id: 1932098,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 1.094,
      known_for_department: "Production",
	    name: "Frank Capra, Jr.",
      gender: 2,
      id: 69599,
      profile_path: null,
      adult: false
},     
{
      popularity: 1.094,
      known_for_department: "Production",
      name: "Lili Fini Zanuck",
      id: 5707,
      profile_path: null,
      adult: false,
	    gender: 1
},
{
      popularity: 1.931,
      known_for_department: "Production",
	    name: "Frank Marshall",
      gender: 2,
      id: 664,
      profile_path: null,
      adult: false,
},
{
      popularity: 1.856,
      known_for_department: "Production",
	    name: "Avi Arad",
      gender: 2,
      id: 7626,
      profile_path: null,
      adult: false
},
{
      popularity: 1.646,
      known_for_department: "Production",
      name: "David Heyman",
      id: 10968,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Sally Potters",
      gender: 0,
      id: 2116382,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Ed Mirisch",
      id: 2419960,
      profile_path: null,
      adult: false,
	    gender:0
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Bonnie Bruckheimer",
      gender: 1,
      id: 58070,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.84,
      known_for_department: "Production",
      name: "Jack L. Warner",
      id: 2663,
      profile_path: null,
      adult: false,
	    gender: 2
},

{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Warner Bros",
      gender: 0,
      id: 2075115,
      profile_path: null,
},
{
      popularity: 0.84,
      known_for_department: "Production",
	    name: "Darryl F. Zanuck",
      gender: 2,
      id: 8502,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.828,
      known_for_department: "Production",
      name: "Richard D. Zanuck",
      id: 1297,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Harrison Zanuck",
      gender: 0,
      id: 41281,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "John Fairbanks",
      gender: 2,
      id: 2280266,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Jill Fairbanks",
      id: 2545545,
      profile_path: null,
      adult: false,
	    gender: 0
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Jerry Fairbanks",
      id: 118221,
      profile_path: null,
      adult: false,
	    gender: 0
},
{
      popularity: 0.828,
      known_for_department: "Production",
      name: "Albert R. Broccoli",
      id: 9861,
      profile_path: null,
      adult: false,
	gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Tony Broccoli",
      gender: 0,
      id: 1984264,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Rika Broccoli",
      gender: 0,
      id: 1984263,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Carl Laemmle Jr.",
      gender: 2,
      id: 1557,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Eugene J. Zukor",
      gender: 0,
      id: 1265587,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.828,
      known_for_department: "Production",
      name: "Konstantin Ernst",
      id: 23435,
      profile_path: null,
      adult: false,
	    gender:2
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Howard Hughes",
      id: 13348,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Terri Howard-Hughes",
      gender: 0,
      id: 1761144,
      profile_path: null,
      adult: false
},
{
      popularity: 0.954,
      known_for_department: "Production",
      name: "Bruce Berman",
      id: 1296,
      profile_path: null,
      adult: false,
	    gender:2
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Pandro S. Berman",
      id: 30174,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Al Berman",
      gender: 0,
      id: 1891750,
      profile_path: null,
      adult: false,
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Robert W. Evans",
      gender: 0,
      id: 2443109,
      profile_path: null,
      adult: false
},
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Wallis Nicita",
      id: 12847,
      profile_path: null,
      adult: false,
	    gender: 2
},
    {
      popularity: 0.98,
      known_for_department: "Production",
	    name: "Rob Wallis",
      gender: 0,
      id: 592936,
      profile_path: null,
      adult: false
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Andrew Mirisch",
      id: 1568718,
      profile_path: null,
      adult: false,
	    gender: 0
},
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Marvin E. Mirisch",
      id: 1895557,
      profile_path: null,
      adult: false,
      known_for: [],
      gender: 0
    },
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Richard Mirisch",
      id: 62740,
      profile_path: null,
      adult: false,
	    gender: 0
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "David Mirisch",
      id: 2419959,
      profile_path: null,
      adult: false,
	  gender: 0
},
{
      popularity: 0.6,
      known_for_department: "Production",
      name: "Robert Mirisch",
      id: 1388446,
      profile_path: null,
      adult: false,
	  gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Production",
	    name: "Marvin Mirisch",
      gender: 0,
      id: 1817049,
      profile_path: null,
      adult: false,
},
    {
      popularity: 0.6,
      known_for_department: "Production",
      name: "Björn Rallare",
      gender: 0,
      id: 1274166,
      profile_path: null,
      adult: false,
},
    {
      popularity: 3.729,
      known_for_department: "Production",
      gender: 2,
      id: 1889137,
      profile_path: null,
      adult: false,
      name: "Eric Koljan"
    },
    {
      popularity: 3.627,
      known_for_department: "Production",
      name: "Danny Lerner",
      gender: 2,
      id: 17208,
      profile_path: null,
      adult: false,
    }    
    
      ],
      sound: [
    {
      popularity: 0.6,
      known_for_department: "Sound",
      name: "Rodriguez",
      id: 1133582,
      profile_path: "/cFxLnQIg146h6DOcVLXIvnW2rG9.jpg",
      adult: false,
      gender: 2
    },   
    {
      popularity: 0.6,
      known_for_department: "Sound",
	    name: "Ramiz Mirishli",
      gender: 0,
      id: 2048837,
      profile_path: "/rHHlfJ2UKnRsbYuhDx8dsPBl751.jpg",
      adult: false,
    },
    {
      popularity: 1.4,
      known_for_department: "Sound",
      name: "Henry Jackman",
      gender: 2,
      id: 227440,
      profile_path: "/wJYFGHG5Vsh8cbiyiS8zpO2SMHb.jpg",
      adult: false,
      gender: 2
    },
{
      popularity: 0.6,
      known_for_department: "Sound",
      name: "Dirk Reichardt",
      id: 48503,
      profile_path: null,
      adult: false,
      gender: 2,
},
{
      popularity: 0.6,
      known_for_department: "Sound",
      name: "Mirist Egal",
      gender: 0,
      id: 1950435,
      profile_path: null,
      adult: false,
    },
    {
      popularity: 0.6,
      known_for_department: "Sound",
	    name: "David Heyman",
      gender: 0,
      id: 2434518,
      profile_path: null,
      adult: false,
	    gender: 2
},
{
      popularity: 0.6,
      known_for_department: "Sound",
	    name: "Nazim Mirishli",
      gender: 0,
      id: 2069655,
      profile_path: null,
      adult: false,
},
    {
      popularity: 0.6,
      known_for_department: "Sound",
      name: "Sam Spiegel",
      gender: 0,
      id: 1344091,
      profile_path: null,
      adult: false,
    },
    {
      popularity: 0.6,
      known_for_department: "Sound",
      name: "Harris Johns",
      gender: 0,
      id: 544759,
      profile_path: null,
      adult: false,
    }
      ],
      art: [
{
        popularity: 0.6,
      known_for_department: "Art",
      name: "Eric Reichardt",
      id: 113832,
      profile_path: null,
      adult: false,
      gender:0
}          
      ],
editors: [
    {
      popularity: 1.4,
      known_for_department: "Editing",
	name: "Veronika Zaplata",
      gender: 1,
      id: 50149,
      profile_path: null,
      adult: false,
},
    {
      popularity: 0.6,
      known_for_department: "Editing",
      name: "Rob Evans",
      id: 2597506,
      profile_path: null,
      adult: false,
	gender: 2
},
    {
      popularity: 0.828,
      known_for_department: "Editing",
	name: "Rebecca Rodriguez",
      gender: 1,
      id: 72030,
      profile_path: null,
      adult: false,
},
],
visuals: [
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "John Nelson",
      id: 1456374,
      profile_path: null,
      adult: false,
      gender: 2
    },
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Joe Bauer",
      id: 1404731,
      profile_path: null,
      adult: false,
      gender: 2
    },
{
      popularity: 0.98,
      known_for_department: "Visual Effects",
      name: "Stephane Ceretti",
      id: 1327025,
      profile_path: null,
      adult: false,
      gender:2    
},
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Marco Maldonado",
      id: 1422415,
      profile_path: null,
      adult: false,
      gender:2
    },
{
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Jerome Chen",
      id: 42261,
      profile_path: null,
      adult: false,
      gender: 2   
},
{
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Guillaume Rocheron",
      id: 1439094,
      profile_path: null,
      adult: false,
      gender: 2
},
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Richard Stammers",
      id: 1384386,
      profile_path: null,
      adult: false,
      gender:2
    },
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Christopher Townsend",
      id: 1408337,
      profile_path: null,
      adult: false,
      gender:2
    },
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Adam Valdez",
      id: 1049272,
      profile_path: null,
      adult: false,
      gender:2
    },
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Michael Ralla",
      id: 2124103,
      profile_path: null,
      adult: false,
      gender: 1
    },
    {
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Erik Nordby",
      id: 1401589,
      profile_path: null,
      adult: false,
      gender:2
    },    
{
      popularity: 0.6,
      known_for_department: "Visual Effects",
      name: "Robert Legato",
      id: 1402031,
      profile_path: null,
      adult: false,
      gender: 2
},
{
      known_for_department: "Visual Effects",
      name: "Robert E. Evans",
      id: 1403474,
      profile_path: null,
      adult: false,
	gender:0
},
{
      popularity: 0.6,
      known_for_department: "Visual Effects",
	name: "Wayne Harry Johnson Jr.",
      gender: 0,
      id: 1622409,
      profile_path: null,
      adult: false,
	}      
],
makeups: [
    {
      popularity: 0.6,
      known_for_department: "Costume & Make-Up",
      name: "Lucia Mirisola",
      id: 1177545,
      profile_path: null,
      adult: false,
	gender: 0
}      
]
    }
  },
  methods: { 
upper () {
  const lower = this.$route.params.city
  const upper = lower.replace(/^\w/, c => c.toUpperCase());
  return upper;
},       
    getDorms () {
      let self = this
      var dene = this.$route.params.distinct
      axios
        .get(`/3/person/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&page=1`)
        .then(response => {
           self.dorms = []
           if (self.$route.params.distinct == 'all') {
          self.dorms = response.data.results
           } else if (self.$route.params.distinct == 'directing') {
          self.dorms = self.directors
           } else if (self.$route.params.distinct == 'writing') {
          self.dorms = self.writers
           } else if (self.$route.params.distinct == 'producer') {
          self.dorms = self.producers
           } else if (self.$route.params.distinct == 'sound') {
          self.dorms = self.sound
           } else if (self.$route.params.distinct == 'editing') {
          self.dorms = self.editors 
           } else if (self.$route.params.distinct == 'visual') {
          self.dorms = self.visuals
           } else if (self.$route.params.distinct == 'makeup') {
          self.dorms = self.makeups                                
           }else {
              response.data.results.forEach(item => {
                  if(item.known_for_department == self.$route.params.distinct) {
                      self.dorms.push(item)
                  }
                
              })
           }
      self.$store.commit(SET_TOTAL_RESULTS, self.dorms.length * 2)
        //  self.district = response.data.district
        //  self.popupDorms = response.data.popups
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    infiniteHandler ($state) {
      let self = this
      axios
        .get(`/3/person/popular?api_key=a11ac97c6bdb99adc0845654be0902a8&page=${this.page}`)
        .then(response => {
          if (response.data.results) {
            this.page += 1
            // this.$router.replace('Page=' + this.page, { silent: true })
            if (response.data.results.length !== 0) {
              response.data.results.forEach(item => {
                  if(item.known_for_department == self.$route.params.distinct) {
                      self.dorms.push(item)
                  }
                
              })
              // self.popupDorms = response.data.results.popups
              $state.loaded()
            } else {
              $state.complete()
            }
          }
        })
    },    
  },
  created () {
    this.gecici = this.$route.params
    this.getDorms()
    this.url = window.location.origin + '/' + this.$route.params.city + '-celebrities/'
  },
  watch: {
    $route () {
      this.getDorms()
    }
  }
}
</script>

<style lang="scss">
</style>
